import dayjs from 'dayjs';
import i18n from '../../i18n';
import type { ChatMessage, ChatTimelineItem } from './chatTypes';

export const RUN_GAP_MINUTES = 5;

export function formatDayLabel(iso: string, now: dayjs.Dayjs = dayjs()): string {
  const day = dayjs(iso);
  if (day.isSame(now, 'day')) {
    return i18n.t('chat.today');
  }
  if (day.isSame(now.subtract(1, 'day'), 'day')) {
    return i18n.t('chat.yesterday');
  }
  const month = day.month() + 1;
  const date = day.date();
  if (day.isSame(now, 'year')) {
    return i18n.t('chat.same_year', { month, day: date });
  }
  return i18n.t('chat.full', { year: day.year(), month, day: date });
}

export function formatMessageTime(iso: string): string {
  return dayjs(iso).format('HH:mm');
}

export function buildTimeline(
  messages: ChatMessage[],
  now: dayjs.Dayjs = dayjs(),
): ChatTimelineItem[] {
  const items: ChatTimelineItem[] = [];
  messages.forEach((message, index) => {
    const prev = messages[index - 1];
    const next = messages[index + 1];
    const current = dayjs(message.createdAt);

    if (!prev || !dayjs(prev.createdAt).isSame(current, 'day')) {
      items.push({
        kind: 'divider',
        key: `divider-${current.format('YYYY-MM-DD')}`,
        label: formatDayLabel(message.createdAt, now),
      });
    }

    const isRunEnd =
      !next ||
      next.direction !== message.direction ||
      !dayjs(next.createdAt).isSame(current, 'day') ||
      dayjs(next.createdAt).diff(current, 'minute') >= RUN_GAP_MINUTES;

    items.push({
      kind: 'message',
      key: message.clientId ?? message.id,
      message,
      isRunEnd,
    });
  });
  return items;
}

let clientIdSeq = 0;

export function createClientId(): string {
  clientIdSeq += 1;
  return `local-${Date.now().toString(36)}-${clientIdSeq}`;
}
